import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=fcc89464&scoped=true"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=fcc89464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc89464",
  null
  
)

export default component.exports